<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .discard-message {
    width: utils.in_rem(452px);
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import ButtonWithTooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/ButtonWithTooltip.svelte";
  import { showToast, ApiError } from "@sourcewhale/core";
  import { saveCandidate } from "@sourcewhale/shared/src/svelte/api/candidates";
  import {
    candidateStore,
    disableAddToContactStore,
    editContactStore,
    showEditContact,
    todosModalItemStore,
  } from "../../stores";
  import {
    confirmDirty,
    handleInvalidItem,
    hasEditedCompanyStore,
    selectedCompanyStore,
  } from "./stores";

  const { dirty } = editContactStore;

  const returnToTodo = () => {
    $showEditContact = false;
  };

  let fromCache = $derived($todosModalItemStore?.fromCache || false);

  const save = async () => {
    $editContactStore.tags = $editContactStore.tagIds;

    let payload = {
      ...$editContactStore,
      candidateId: $candidateStore.candidateId,
      fromCache,
    };

    // If user has manually edited, always nullify company
    if ($hasEditedCompanyStore) {
      payload.companyId = null;
    }
    // If a company is selected use its ID
    else if ($selectedCompanyStore.companyId) {
      payload.companyId = $selectedCompanyStore.companyId;
    }
    // Default case: no company selected, explicitly set to null
    else {
      payload.companyId = null;
    }

    if (fromCache) {
      payload.aiToDoId = $todosModalItemStore.aiToDoId;
    }

    try {
      if (fromCache) {
        $disableAddToContactStore = true;
      }
      await saveCandidate(payload);
      showToast({
        title: "Success!",
        subtitle: "Contact details saved.",
        type: "success",
      });
      returnToTodo();
    } catch (error) {
      const { cause } = error;
      if (cause instanceof ApiError && cause.status === 400) {
        const message = cause.message.replace(/^"|"$/g, "");
        if (message.includes("Invalid")) {
          handleInvalidItem(message);
          return;
        }
      }
      throw error;
    }
  };
</script>

<Button
  style="width: 11.375rem;"
  kind="secondary"
  onclick={$dirty && !$candidateStore.isDeleted ? confirmDirty : returnToTodo}
  size="large"
>
  Cancel
</Button>

{#if $candidateStore.isDeleted}
  <ButtonWithTooltip style="width: 11.375rem;" class="disabled" size="large">
    <span slot="tooltip">You cannot save changes to a deleted contact.</span>
    Save Changes
  </ButtonWithTooltip>
{:else}
  <Button
    style="width: 11.375rem;"
    class={$dirty ? "" : "disabled"}
    onclick={$dirty ? save : null}
    size="large"
  >
    {fromCache ? "Add Contact" : "Save Changes"}
  </Button>
{/if}
